import { isEmpty } from 'lodash';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Space, Table, Tag } from 'tdesign-react';

export default function PermissionsError({ info, primaryClusterName, recoveryClusterName, topic }) {
  const data = useMemo(() => {
    const empty = {
      '-': [],
    };
    let primaryPermissions = info[primaryClusterName];
    let recoveryPermissions = info[recoveryClusterName];
    if (isEmpty(primaryPermissions)) primaryPermissions = empty;
    if (isEmpty(recoveryPermissions)) recoveryPermissions = empty;

    const list = [];
    Object.entries(primaryPermissions).forEach(([key, value], index) => {
      list.push({
        clusterName: primaryClusterName,
        isPrimary: true,
        roleName: key,
        perms: value,
        clusterNameRowspan: index === 0 ? Object.entries(primaryPermissions).length : 1,
        i: `${primaryClusterName}-${key}`,
      });
    });

    Object.entries(recoveryPermissions).forEach(([key, value], index) => {
      list.push({
        clusterName: recoveryClusterName,
        roleName: key,
        perms: value,
        clusterNameRowspan: index === 0 ? Object.entries(recoveryPermissions).length : 1,
        i: `${recoveryClusterName}-${key}`,
      });
    });

    return list;
  }, [info, primaryClusterName, recoveryClusterName]);

  const columns = [
    {
      title: '所属集群',
      colKey: 'clusterName',
      width: 260,
      cell: ({ row }) => {
        return `${row.clusterName} （${row.isPrimary ? '主' : '备'}）`;
      },
    },
    {
      title: 'RoleName',
      colKey: 'roleName',
      width: 240,
    },
    {
      title: '权限',
      colKey: 'perms',
      cell: ({ row }) => (
        <Space breakLine size={4}>
          {isEmpty(row.perms) ? '-' : row.perms.map((item) => <Tag key={item}>{item}</Tag>)}
        </Space>
      ),
    },
  ];

  const rowspanAndColspan = ({ row, col }) => {
    console.log(row, col);
    if (col.colKey === 'clusterName' && row.clusterNameRowspan) {
      return {
        rowspan: row.clusterNameRowspan,
      };
    }
  };

  return (
    <>
      <Header theme='primary' variant='light'>
        {topic}
      </Header>
      <Table
        style={{ width: 880 }}
        data={data}
        columns={columns}
        rowKey='i'
        bordered
        rowspanAndColspan={rowspanAndColspan}
      />
    </>
  );
}

const Header = styled(Tag)`
  margin: 4px 0 7px 2px;
`;
